export default "/assets/images/mila-feed-09.7789522fe1a57cfc.mp4";